"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserStateResponse = getUserStateResponse;
function getUserStateResponse(state) {
    if (state.platform.user?.status === 'done') {
        if (state.platform.user.data) {
            return state.platform.user.data;
        }
        else {
            throw new Error('Invalid platform state, user data is not set.');
        }
    }
    else {
        throw new Error('Cannot get user id, user is not logged in.');
    }
}
